module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)]) : _c('div', [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("member.labels.createMember")) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }), _c('div', {
    staticClass: "p-b-15"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-md-6"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": _vm.urlCreateMember()
    }
  }, [_c('i', {
    staticClass: "icon md-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "text hidden-sm-down"
  }, [_vm._v(" " + _vm._s(_vm.$t("action.create")) + " ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.users.length > 0) ? _c('div', {
    staticClass: "table-striped table-hover table-responsive"
  }, [_c('table', {
    staticClass: "table is-indent"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cell-50",
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "cell-500",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-500",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-150 hidden-sm",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.role")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-150"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user, index) {
    return _c('tr', [_c('td', {
      staticClass: "cell-50"
    }, [_c('a', {
      staticClass: "avatar"
    }, [(user.display_image.sizes.default.url) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": user.display_image.sizes.default.url,
        "alt": "image-profile"
      }
    }) : _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": "/static/images/user.png",
        "alt": "image-profile"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "cell-550"
    }, [_vm._v("\n                    " + _vm._s(user.name) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "cell-500"
    }, [_vm._v("\n                    " + _vm._s(user.email) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "cell-150 hidden-sm"
    }, [(user.role == 'manager') ? _c('span', {
      staticClass: "tag tag-danger"
    }, [_vm._v("Manager")]) : _c('span', {
      staticClass: "tag tag-default"
    }, [_vm._v("User")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-150"
    }, [_c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": _vm.urlEditMember(user.id),
        "data-original-title": "Edit"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("action.manage")) + "\n                    ")])], 1)])
  }))]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.pagination.total_page > 1)),
      expression: "(pagination.total_page > 1)"
    }],
    attrs: {
      "pageCount": _vm.pagination.total_page,
      "prevText": '«',
      "nextText": '»',
      "clickHandler": _vm.changePage,
      "containerClass": 'pagination pull-right',
      "pageClass": 'page-item',
      "pageLinkClass": 'page-link',
      "prevClass": 'page-item',
      "prevLinkClass": 'page-link',
      "nextClass": 'page-item',
      "nextLinkClass": 'page-link'
    }
  })], 1) : _c('div', {
    staticClass: "alert alert-primary alert-dismissible"
  }, [_vm._v("\n            There is no members.\n          ")])])]), _vm._v(" "), _c('p')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fc3e9d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/members/MembersBrowser.vue
// module id = 549
// module chunks = 1